import { gql } from '@apollo/client';

export default gql`
  query IsEligibleToTravelPerTravelDocs($reference: String!, $lastName: String!) {
    isEligibleToTravelPerTravelDocs(bookingReference: $reference, lastName: $lastName) {
      passengerUUID
      readyToTravel
    }
  }
`;
